import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import {Link, withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import DataTableWrapperForListing from "../datable/DataTableWrapperForListing";
import BasePopup from "../popup/BasePopup";
import {API_SALES_MULTI_SUBSCRIPTION_CANCEL, API_SALES_SUBSCRIPTION_CANCEL, API_SALES_SUBSCRIPTION_COUNT, API_SALES_SUBSCRIPTION_LIST, API_SALES_SUBSCRIPTION_LIST_DOWNLOAD, API_SALES_SUBSCRIPTION_LIST_INHOUSE_DOWNLOAD, URL_PRODUCT_DETAIL, URL_REQUEST_LIST, URL_SALES_SUBSCRIPTION} from '../../utils/urlConstants';
import axios from "axios";
import {AXIOS_CLIENT_TIMEOUT, searchRange} from "../../utils/globalConstants";
import {toast} from "react-toastify";
import {handleHttpError} from "../../utils/ErrorUtils";
import {startLoading, stopLoading} from '../../ducks/loading';
import Tooltip from '../common/Tooltip';
import Select from '../search-bar/Select';
import TextInput from '../search-bar/TextInput';
import DatePickerX from '../common/DatePickerX';
import {convertSearchTextToCommaDelimiterString, directDownload, parseSearchValue, sortOptions, subtractDateByDay} from '../../utils/CommonUtils';
import {subscriptionStatusOptions} from '../../utils/SelectOptions';

class SubscriptionListPanel extends Component {
    constructor(props) {
        super(props);
        this.httpClient = axios.create({timeout: AXIOS_CLIENT_TIMEOUT});

        this.defaultSortName = "SUBSCRIPTION_START_DATE";

        this.state = {
            subscriptions: [],

            searchDateButton: searchRange.ONE_WEEK,
            searchKeywordType: "",
            searchKeywordText: "",
            searchCountry: "",
            searchSubscriptionStatus: "",
            searchSortName: this.defaultSortName,
            searchSortAsc: false,

            getSubscriptionDateStart: undefined,
            setSubscriptionDateStart: undefined,
            getSubscriptionDateEnd: undefined,
            setSubscriptionDateEnd: undefined,

            totalRecord: 0,
            totalPage: 0,
            pageIndex: 1,
            pageSize: 15,

            openDownloadPopup: false,
            downloadRequestId: '',

            openSinglesCancelSubscriptionPopup: false,
            openMultipleCancelSubscriptionPopup: false,
            currentSubscription: undefined,
            selectedSubscriptions: [],
        }

        this.defaultColumns = [
            {dataField: "productIdLink", text: this.props.t("PRODUCT_ID"), headerStyle: {width: "12rem"}, sort: true, hidden: false, classes: () => "text-truncate"},
            {dataField: "productName", text: this.props.t("PRODUCT_NAME"), headerStyle: {width: "14rem"}, sort: true, hidden: false, classes: () => "text-truncate"},
            {dataField: "productStatus", text: this.props.t("PRODUCT_STATUS"), headerStyle: {width: "10rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "subscriptionIdLink", text: this.props.t("SUBSCRIPTION_ID"), headerStyle: {width: "12rem"}, sort: true, hidden: false, classes: () => "text-truncate"},
            {dataField: "buyer", text: this.props.t("BUYER_EMAIL"), headerStyle: {width: "14rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "buyerUid", text: this.props.t("BUYER_UID"), headerStyle: {width: "10rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "orderCustomerId", text: this.props.t("ORDER_CUSTOMER_ID"), headerStyle: {width: "12rem"}, sort: true, hidden: false, classes: () => "text-truncate"},
            {dataField: "country", text: this.props.t("COUNTRY"), headerStyle: {width: "12rem"}, sort: true, hidden: false, classes: () => "text-truncate"},
            {dataField: "currency", text: this.props.t("CURRENCY"), headerStyle: {width: "10rem"}, sort: true, hidden: false, classes: () => "text-truncate"},
            {dataField: "paymentAmountDisplay", text: this.props.t("PAYMENT_AMOUNT"), headerStyle: {width: "10rem"}, sort: true, hidden: false, classes: () => "text-truncate"},
            {dataField: "subscriptionStatus", text: this.props.t("SUBSCRIPTION_STATUS"), headerStyle: {width: "12rem"}, sort: true, hidden: false, classes: () => "text-truncate"},
            {dataField: "modelYear", text: this.props.t("DEVICE_YEAR"), headerStyle: {width: "10rem"}, sort: true, hidden: false, classes: () => "text-truncate"},
            {dataField: "latestPaymentStatus", text: this.props.t("LATEST_PAYMENT_STATUS"), headerStyle: {width: "12rem"}, sort: true, hidden: false, classes: () => "text-truncate"},
            {dataField: "subscriptionStartDate", text: this.props.t("SUBSCRIPTION_START_DATE"), headerStyle: {width: "12rem"}, sort: true, hidden: false, classes: () => "text-truncate"},
            {dataField: "subscriptionEndDate", text: this.props.t("SUBSCRIPTION_END_DATE"), headerStyle: {width: "12rem"}, sort: true, hidden: false, classes: () => "text-truncate"},
            {dataField: "lastPaymentDate", text: this.props.t("LAST_PAYMENT_DATE"), headerStyle: {width: "12rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "nextPaymentDate", text: this.props.t("NEXT_PAYMENT_DATE"), headerStyle: {width: "12rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "cancelSubscription", text: this.props.t("CANCEL_SUBSCRIPTION"), headerStyle: {width: "12rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
        ]

        this.multipleCancelSubscriptionColumns = [
            {dataField: "productIdLink", text: this.props.t("PRODUCT_ID"), headerStyle: {width: "12rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "productName", text: this.props.t("PRODUCT_NAME"), headerStyle: {width: "14rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "productStatus", text: this.props.t("PRODUCT_STATUS"), headerStyle: {width: "10rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "subscriptionIdLink", text: this.props.t("SUBSCRIPTION_ID"), headerStyle: {width: "12rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "buyer", text: this.props.t("BUYER_EMAIL"), headerStyle: {width: "14rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "buyerUid", text: this.props.t("BUYER_UID"), headerStyle: {width: "10rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "orderCustomerId", text: this.props.t("ORDER_CUSTOMER_ID"), headerStyle: {width: "12rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "country", text: this.props.t("COUNTRY"), headerStyle: {width: "12rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "currency", text: this.props.t("CURRENCY"), headerStyle: {width: "10rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "paymentAmountDisplay", text: this.props.t("PAYMENT_AMOUNT"), headerStyle: {width: "10rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "subscriptionStatus", text: this.props.t("SUBSCRIPTION_STATUS"), headerStyle: {width: "12rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "modelYear", text: this.props.t("DEVICE_YEAR"), headerStyle: {width: "10rem"}, sort: true, hidden: false, classes: () => "text-truncate"},
            {dataField: "latestPaymentStatus", text: this.props.t("LATEST_PAYMENT_STATUS"), headerStyle: {width: "12rem"}, sort: true, hidden: false, classes: () => "text-truncate"},
            {dataField: "subscriptionStartDate", text: this.props.t("SUBSCRIPTION_START_DATE"), headerStyle: {width: "12rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "subscriptionEndDate", text: this.props.t("SUBSCRIPTION_END_DATE"), headerStyle: {width: "12rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "lastPaymentDate", text: this.props.t("LAST_PAYMENT_DATE"), headerStyle: {width: "12rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "nextPaymentDate", text: this.props.t("NEXT_PAYMENT_DATE"), headerStyle: {width: "12rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
        ]

        this.keywordTypeOptions = [
            {value: "BUYER", label: this.props.t("BUYER_EMAIL")},
            {value: "SUBSCRIPTION_ID", label: this.props.t("SUBSCRIPTION_ID")},
            {value: "PRODUCT_ID", label: this.props.t("PRODUCT_ID")},
            {value: "PRODUCT_NAME", label: this.props.t("PRODUCT_NAME")},
        ]

        this.sortFieldMapping = {
            'subscriptionIdLink': 'SUBSCRIPTION_ID',
            'productIdLink': 'PRODUCT_ID',
            'productName': 'PRODUCT_NAME',
            'orderCustomerId': 'ORDER_CUSTOMER_ID',
            'country': 'COUNTRY',
            'currency': 'CURRENCY',
            'paymentAmountDisplay': 'PAYMENT_AMOUNT',
            'subscriptionStatus': 'SUBSCRIPTION_STATUS',
            'subscriptionStartDate': 'SUBSCRIPTION_START_DATE',
            'subscriptionEndDate': 'SUBSCRIPTION_END_DATE',
        }
    }

    handleChangeSearchDateButton = (value) => () => {
        this.setState({searchDateButton: value});
        this.state.setSubscriptionDateEnd(new Date());
        this.state.setSubscriptionDateStart(subtractDateByDay(new Date(), value));
    }

    searchBody = () => {
        return {
            cpAppId: this.props.carousel.selectedAppId,
            keywordType: parseSearchValue(this.state.searchKeywordType),
            keywordText: convertSearchTextToCommaDelimiterString(this.state.searchKeywordText),
            dateStart: this.state.getSubscriptionDateStart(),
            dateEnd: this.state.getSubscriptionDateEnd(),
            currency: parseSearchValue(this.state.searchCurrency),
            country: parseSearchValue(this.state.searchCountry),
            subscriptionStatus: parseSearchValue(this.state.searchSubscriptionStatus),
        }
    }

    handleSearch = () => {
        const body = {
            ...this.searchBody(),
            sortName: this.state.searchSortName,
            sortAsc: this.state.searchSortAsc,
            pageIndex: this.state.pageIndex,
            pageSize: this.state.pageSize,
        }

        return new Promise((resolve, reject) => {
            this.props.startLoading();
            this.httpClient
                .get(API_SALES_SUBSCRIPTION_LIST, {params: body})
                .then(response => {
                    const responseData = response.data;
                    if (responseData.data && responseData.data.length > 0) {
                        this.setState({
                            subscriptions: responseData.data,
                            totalRecord: responseData.records,
                            totalPage: responseData.total,
                        });
                    } else {
                        this.setState({
                            subscriptions: [],
                            totalRecord: 0,
                            totalPage: 0,
                        });
                    }
                    this.props.stopLoading();
                })
                .catch(error => {
                    handleHttpError(this.props.t, this.props.history, error);
                    this.props.stopLoading();
                    reject(error);
                })
        })
    }

    handleClickSearch = () => {
        this.setState({
            pageIndex: 1,
        }, this.handleSearch);
    }

    handleReset = () => {
        this.state.setSubscriptionDateEnd(new Date());
        this.state.setSubscriptionDateStart(subtractDateByDay(new Date(), 7));

        this.setState({
            searchDateButton: searchRange.ONE_WEEK,
            searchKeywordType: "",
            searchKeywordText: "",
            searchCountry: "",
            searchCurrency: "",
            searchSubscriptionStatus: "",
            searchSortName: this.defaultSortName,
            searchSortAsc: false,
            pageIndex: 1,
            pageSize: 15,
            totalRecord: 0,
            totalPage: 0,
        }, this.handleSearch);
    }

    handleDownload = () => {
        const body = this.searchBody();
        return new Promise((resolve, reject) => {
            this.props.startLoading();
            this.httpClient
                .get(API_SALES_SUBSCRIPTION_COUNT, {params: body})
                .then(async response => {
                    const csvBatchDownload = response.data;
                    if (csvBatchDownload) {
                        await this.handleDownloadCsvBatch();
                    } else {
                        await this.handleDownloadInHouse();
                    }
                    this.props.stopLoading();
                })
                .catch(error => {
                    handleHttpError(this.props.t, this.props.history, error);
                    this.props.stopLoading();
                    reject(error);
                })
        })
    }

    handleDownloadInHouse = async () => {
        const body = this.searchBody();
        return new Promise((resolve, reject) => {
            this.props.startLoading();
            this.httpClient
                .get(API_SALES_SUBSCRIPTION_LIST_INHOUSE_DOWNLOAD, {params: body})
                .then(response => {
                    directDownload(response);
                    this.props.stopLoading();
                })
                .catch(error => {
                    handleHttpError(this.props.t, this.props.history, error);
                    this.props.stopLoading();
                    reject(error);
                })
        })
    }

    handleDownloadCsvBatch = async () => {
        const body = this.searchBody();
        return new Promise((resolve, reject) => {
            this.props.startLoading();
            this.httpClient
                .get(API_SALES_SUBSCRIPTION_LIST_DOWNLOAD, {params: body})
                .then(response => {
                    const requestId = response.data;
                    this.setState({
                        openDownloadPopup: true,
                        downloadRequestId: requestId,
                    })
                    this.props.stopLoading();
                })
                .catch(error => {
                    handleHttpError(this.props.t, this.props.history, error);
                    this.props.stopLoading();
                    reject(error);
                })
        })
    }

    handleTableChange = (pageIndex, pageSize) => {
        this.setState({
            pageIndex: pageIndex,
            pageSize: pageSize,
        }, this.handleSearch);
    }

    handleTableSort = (sortOrder, sortName) => {
        this.setState({
            searchSortName: this.sortFieldMapping[sortName],
            searchSortAsc: sortOrder === 'asc',
        }, this.handleSearch);
    }

    handleRowSelect = (isSelect, rows) => {
        rows.forEach(row => {
            if (isSelect) {
                this.setState(prevState => {
                    return {
                        selectedSubscriptions: [...prevState.selectedSubscriptions, row.subscription]
                    }
                })
            } else {
                this.setState(prevState => {
                    return {
                        selectedSubscriptions: prevState.selectedSubscriptions.filter(subscription => subscription.subscriptionId !== row.subscription.subscriptionId)
                    }
                })
            }
        })
    }

    handleOpenSingleCancelSubscription = (subscription) => {
        this.setState({
            openSingleCancelSubscriptionPopup: true,
            currentSubscription: subscription,
        })
    }

    handleCloseSingleCancelSubscription = () => {
        this.setState({
            openSingleCancelSubscriptionPopup: false,
            currentSubscription: undefined,
        })
    }

    handleSingleCancelSubscription = () => {
        const body = {
            subscriptionId: this.state.currentSubscription.subscriptionId,
            buyerGuid: this.state.currentSubscription.buyerGuid,
            buyerUid: this.state.currentSubscription.buyerUid,
            langCode: this.props.i18n.language,
            countryCode: this.state.currentSubscription.countryCode,
        }
        return new Promise((resolve, reject) => {
            this.props.startLoading();
            this.httpClient
                .post(API_SALES_SUBSCRIPTION_CANCEL, body)
                .then(response => {
                    const responseData = response.data;
                    if (responseData.code === '100000') {
                        this.handleClickSearch();
                        this.handleCloseSingleCancelSubscription();
                        toast(this.props.t("CANCEL_SUBSCRIPTION_SUCCESS"));
                    } else {
                        toast(response.data.name);
                    }
                    this.props.stopLoading();
                })
                .catch(error => {
                    handleHttpError(this.props.t, this.props.history, error);
                    reject(error);
                    this.props.stopLoading();
                })
        })
    }

    handleOpenMultipleCancelSubscription = () => {
        this.setState({
            openMultipleCancelSubscriptionPopup: true,
        })
    }

    handleCloseMultipleCancelSubscription = () => {
        this.setState({
            openMultipleCancelSubscriptionPopup: false,
        })
    }

    handleMultipleCancelSubscription = () => {
        const body = this.state.selectedSubscriptions.map(subscription => {
            return {
                subscriptionId: subscription.subscriptionId,
                buyerGuid: subscription.buyerGuid,
                buyerUid: subscription.buyerUid,
                countryCode: subscription.countryCode,
                langCode: this.props.i18n.language,
            }
        })
        return new Promise((resolve, reject) => {
            this.props.startLoading();
            this.httpClient
                .post(API_SALES_MULTI_SUBSCRIPTION_CANCEL, body)
                .then(response => {
                    this.handleClickSearch();
                    this.handleCloseMultipleCancelSubscription();
                    this.setState({selectedSubscriptions: []});
                    toast(`${response.data.completeCancelRequest} / ${response.data.totalCancelRequest} Subscriptions Cancelled`);
                    this.props.stopLoading();
                })
                .catch(error => {
                    handleHttpError(this.props.t, this.props.history, error);
                    this.props.stopLoading();
                    reject(error);
                })
        })
    }

    getCountryOptions = () => {
        return this.props.countriesInformation.map(country => {
            return {
                value: country.country,
                label: `${country.countryName}`
            }
        }).sort(sortOptions);
    }

    getCurrencyOptions = () => {
        return this.props.countriesInformation
            .map(country => country.currency)
            .filter((value, index, array) => array.indexOf(value) === index)
            .map(currency => {
                return {
                    value: currency,
                    label: currency,
                }
            })
            .sort(sortOptions);
    }

    render() {
        return (
            <div className="tab-pane active" role="tabpanel">
                <div className={'search_field'}>
                    <div className={'form-group row align-items-center'}>
                        <label className={'col col-form-label'}>
                            {this.props.t('KEYWORD')}
                            <Tooltip>
                                {this.props.t("KEYWORD_MULTI_SEARCH_TOOLTIP")}
                            </Tooltip>
                        </label>
                        <div className={'col d-flex flex-row align-items-center'} style={{gap: '0.6rem'}}>
                            <Select
                                options={this.keywordTypeOptions}
                                value={this.state.searchKeywordType}
                                onChange={value => this.setState({searchKeywordType: value, searchKeywordText: ''})}
                                placeholder={this.props.t('CHOOSE_KEYWORD')}
                                style={{minWidth: '14rem'}}
                                noMaxHeight={true}
                            />
                            <TextInput
                                placeholder={this.props.t('PLEASE_ENTER_KEYWORD')}
                                value={this.state.searchKeywordText}
                                onChange={value => this.setState({searchKeywordText: value})}
                                disabled={!this.state.searchKeywordType}
                            />
                            <button type={'button'} onClick={this.handleClickSearch} className={'btn btn-primary'}>
                                {this.props.t('SEARCH')}
                            </button>
                            <button type={'button'} onClick={this.handleReset} className={'btn btn-icon'} style={{minWidth: '4rem'}}>
                                <i className={'icon icon-refrash'}/>
                            </button>
                            <button type={'button'} onClick={this.handleDownload} className={'btn btn-outline-primary'}>
                                {this.props.t('DOWNLOAD')}
                            </button>
                        </div>
                    </div>
                    <div className={'form-group row align-items-center'}>
                        <label className={'col col-form-label'}>
                            {this.props.t('SUBSCRIPTION_DATE')}
                        </label>
                        <div className={'col d-flex flex-row align-items-center'} style={{gap: '0.6rem'}}>
                            <div style={{width: '8rem'}}>
                                <DatePickerX
                                    onInit={datePicker => this.setState({
                                        getSubscriptionDateStart: datePicker.getValue,
                                        setSubscriptionDateStart: datePicker.setValue,
                                    })}
                                    defaultValue={subtractDateByDay(new Date(), this.state.searchDateButton)}
                                />
                            </div>
                            <span>
                                ~
                            </span>
                            <div style={{width: '8rem'}}>
                                <DatePickerX
                                    onInit={datePicker => this.setState({
                                        getSubscriptionDateEnd: datePicker.getValue,
                                        setSubscriptionDateEnd: datePicker.setValue,
                                    })}
                                    defaultValue={new Date()}
                                />
                            </div>
                            <div className={'btn-group'}>
                                <button type={'button'} onClick={this.handleChangeSearchDateButton(searchRange.ONE_WEEK)} className={`btn btn-outline-500 ${this.state.searchDateButton === searchRange.ONE_WEEK ? 'checked' : ''}`}>
                                    {this.props.t('ONE_WEEK')}
                                </button>
                                <button type={'button'} onClick={this.handleChangeSearchDateButton(searchRange.ONE_MONTH)} className={`btn btn-outline-500 ${this.state.searchDateButton === searchRange.ONE_MONTH ? 'checked' : ''}`}>
                                    {this.props.t('ONE_MONTH')}
                                </button>
                                <button type={'button'} onClick={this.handleChangeSearchDateButton(searchRange.SIX_MONTHS)} className={`btn btn-outline-500 ${this.state.searchDateButton === searchRange.SIX_MONTHS ? 'checked' : ''}`}>
                                    {this.props.t('SIX_MONTHS')}
                                </button>
                                <button type={'button'} onClick={this.handleChangeSearchDateButton(searchRange.ONE_YEAR)} className={`btn btn-outline-500 ${this.state.searchDateButton === searchRange.ONE_YEAR ? 'checked' : ''}`}>
                                    {this.props.t('ONE_YEAR')}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className={'form-group row align-items-start'}>
                        <label className={'col col-form-label'}>
                            {this.props.t('FILTERS')}
                        </label>
                        <div className={'col d-flex flex-row'}>
                            <div style={{display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '0.6rem'}}>
                                <Select
                                    options={this.getCountryOptions()}
                                    value={this.state.searchCountry}
                                    onChange={value => this.setState({searchCountry: value})}
                                    placeholder={this.props.t('COUNTRY')}
                                    style={{minWidth: '14rem'}}
                                />
                                <Select
                                    options={this.getCurrencyOptions()}
                                    value={this.state.searchCurrency}
                                    onChange={value => this.setState({searchCurrency: value})}
                                    placeholder={this.props.t('CURRENCY')}
                                    style={{minWidth: '14rem'}}
                                />
                                <Select
                                    options={subscriptionStatusOptions}
                                    value={this.state.searchSubscriptionStatus}
                                    onChange={value => this.setState({searchSubscriptionStatus: value})}
                                    placeholder={this.props.t('SUBSCRIPTION_STATUS')}
                                    style={{minWidth: '14rem'}}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <DataTableWrapperForListing
                    noSelect
                    wrapperClasses="table-responsive"
                    keyField="index"
                    columns={this.defaultColumns}
                    page={this.state.pageIndex}
                    sizePerPage={this.state.pageSize}
                    totalSize={this.state.totalRecord}
                    rows={this.state.subscriptions.map(subscription => {
                        return {
                            ...subscription,
                            index: subscription.subscriptionId,
                            subscription: subscription,
                            productIdLink: (
                                <Link
                                    title={subscription.cpProductId}
                                    to={`${URL_PRODUCT_DETAIL}/${subscription.productId}`}
                                >
                                    {subscription.cpProductId}
                                </Link>
                            ),
                            subscriptionIdLink: (
                                <Link
                                    title={subscription.subscriptionId}
                                    to={`${URL_SALES_SUBSCRIPTION}/${subscription.subscriptionId}`}
                                >
                                    {subscription.subscriptionId}
                                </Link>
                            ),
                            cancelSubscription: subscription.subscriptionStatusCode === '00' ? (
                                <button
                                    className={'btn btn-outline-primary'}
                                    onClick={() => this.handleOpenSingleCancelSubscription(subscription)}
                                >
                                    {this.props.t("CANCEL_SUBSCRIPTION")}
                                </button>
                            ) : '-'
                        }
                    })}
                    onTableSort={this.handleTableSort}
                    onTableChange={this.handleTableChange}
                    onRowSelect={this.handleRowSelect}
                    nonSelectableRows={
                        this.state.subscriptions
                            .filter(subscription => subscription.subscriptionStatusCode !== '00')
                            .map(subscription => subscription.subscriptionId)
                    }
                    defaultSorted={[{dataField: 'subscriptionStartDate', order: 'desc'}]}
                />
                <div className={'d-flex flex-row mt-10'}>
                    <button
                        type={'button'}
                        className={`btn btn-primary ${this.state.selectedSubscriptions.length === 0 ? 'disabled' : ''}`}
                        disabled={this.state.selectedSubscriptions.length === 0}
                        onClick={this.handleOpenMultipleCancelSubscription}
                    >
                        {this.props.t("CANCEL_SUBSCRIPTIONS")}
                    </button>
                </div>
                <BasePopup
                    open={this.state.openDownloadPopup}
                    className={"modal-sm"}
                    style={{maxWidth: '26rem'}}
                    title={this.props.t("CSV_DOWNLOAD_REQUEST")}
                    onClose={() => this.setState({openDownloadPopup: false})}
                    body={(
                        <div>
                            {this.props.t("CSV_DOWNLOAD_REQUEST_MESSAGE").replace("{REQUEST_ID}", this.state.downloadRequestId)}
                        </div>
                    )}
                    footer={(
                        <div className={'d-flex flex-row'} style={{gap: '0.6rem'}}>
                            <button type="button" className="btn btn-primary" onClick={() => this.setState({openDownloadPopup: false})}>
                                {this.props.t("OK")}
                            </button>
                            <Link to={URL_REQUEST_LIST} className="btn btn-outline-primary">
                                {this.props.t("CSV_DOWNLOAD_REPOSITORY")}
                            </Link>
                        </div>
                    )}
                />
                {this.state.currentSubscription &&
                    <BasePopup
                        open={this.state.openSingleCancelSubscriptionPopup}
                        className={"modal-sm"}
                        style={{maxWidth: '26rem'}}
                        title={this.props.t("CANCEL_SUBSCRIPTION")}
                        onClose={this.handleCloseSingleCancelSubscription}
                        body={(
                            <div>
                                {this.props.t("DO_YOU_WANT_TO_CANCEL_THE_SUBSCRIPTION")}
                            </div>
                        )}
                        footer={(
                            <div className={'d-flex flex-row'} style={{gap: '0.6rem'}}>
                                <button type="button" className="btn btn-primary" onClick={this.handleSingleCancelSubscription}>
                                    {this.props.t("OK")}
                                </button>
                                <button type="button" className="btn btn-outline-primary" onClick={this.handleCloseSingleCancelSubscription}>
                                    {this.props.t("CANCEL")}
                                </button>
                            </div>
                        )}
                    />
                }
                <BasePopup
                    open={this.state.openMultipleCancelSubscriptionPopup}
                    className="modal-lg"
                    title={this.props.t('CANCEL_SUBSCRIPTIONS')}
                    onClose={this.handleCloseMultipleCancelSubscription}
                    body={
                        <DataTableWrapperForListing
                            noSelect
                            hideSelectColumn
                            disableFooter
                            wrapperClasses="table-responsive"
                            keyField="index"
                            columns={this.multipleCancelSubscriptionColumns}
                            rows={this.state.selectedSubscriptions.map(subscription => {
                                return {
                                    ...subscription,
                                    index: subscription.subscriptionId,
                                    subscription: subscription,
                                    productIdLink: (
                                        <Link
                                            title={subscription.cpProductId}
                                            to={`${URL_PRODUCT_DETAIL}/${subscription.productId}`}
                                        >
                                            {subscription.cpProductId}
                                        </Link>
                                    ),
                                    subscriptionIdLink: (
                                        <Link
                                            title={subscription.subscriptionId}
                                            to={`${URL_SALES_SUBSCRIPTION}/${subscription.subscriptionId}`}
                                        >
                                            {subscription.subscriptionId}
                                        </Link>
                                    ),
                                }
                            })}
                        />
                    }
                    footer={
                        <div className={'d-flex flex-row'} style={{gap: '0.6rem'}}>
                            <button type="button" className="btn btn-secondary" onClick={this.handleMultipleCancelSubscription}>
                                {this.props.t("CANCEL_SUBSCRIPTIONS")}
                            </button>
                            <button type="button" className="btn btn-outline-secondary" onClick={this.handleCloseMultipleCancelSubscription}>
                                {this.props.t("CANCEL")}
                            </button>
                        </div>
                    }
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        carousel: state.carousel,
        countriesInformation: state.countriesInformation
    };
};

const mapDispatchToProps = {
    startLoading: startLoading,
    stopLoading: stopLoading
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(withRouter(SubscriptionListPanel)));